import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAuth from '../utils/useAuth';
import enStockLogo from '../assets/logos/en_stock_logo.svg';
import defaultImage from '../assets/images/image-not-found.png';
import { truncateString } from '../utils/truncate';
import { formatUnits, formatArrivalDate, getArrivals } from '../utils/arrivals';
import '../styles/components/ProductCard.scss';

const ProductCard = ({ product }) => {
  const [thumbnail1, setThumbnail1] = useState(defaultImage);
  const [thumbnail2, setThumbnail2] = useState(null);
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  useEffect(() => {
    if (product && Array.isArray(product.image_files) && product.image_files.length > 0) {
      const BASE_URL = process.env.REACT_APP_S3_BASE_URL;
      setThumbnail1(`${BASE_URL}/thumbnails/${product.image_files[0]}`);
      
      if (product.image_files.length > 1) {
        setThumbnail2(`${BASE_URL}/thumbnails/${product.image_files[1]}`);
      } else {
        setThumbnail2(null);
      }
    } else {
      setThumbnail1(defaultImage);
      setThumbnail2(null);
    }
  }, [product]);

  if (!product) {
    return null;
  }

  const hasMultipleImages = Boolean(thumbnail2);
  const hoverImage = hasMultipleImages ? thumbnail2 : thumbnail1;

  const handleScrollToTop = () => {
    if (location.pathname.startsWith('/productos')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const displayPublicPrice = product.publicPrice && product.publicPrice !== 'N/A' && product.publicPrice !== 'n/a'
    ? product.publicPrice
    : 'Precio no disponible';

  const nextArrival = getArrivals(product)[0] || null;
  const nextArrivalDate = nextArrival ? formatArrivalDate(nextArrival.fecha) : null;

  return (
    <div className="ProductCard">
      {product.isNew && (
        <div className="ProductCard__badge ProductCard__badge--new">
          NUEVO
        </div>
      )}
      <div className="ProductCard__image">
        <Link to={`/productos/${product.slug}`} aria-label={`Ver detalles de ${product.title}`}>
          <div className="ProductCard__image-wrapper">
            {product.type === 'deal' && <span className="ProductCard__badge">Oferta</span>}
            <img
              src={thumbnail1}
              alt={product.title || 'Imagen por defecto'}
              className="ProductCard__img"
              onClick={handleScrollToTop}
              onMouseOver={hasMultipleImages ? (e) => (e.currentTarget.src = hoverImage) : undefined}
              onMouseOut={hasMultipleImages ? (e) => (e.currentTarget.src = thumbnail1) : undefined}
              loading="lazy"
              onError={(e) => { e.currentTarget.src = defaultImage; }} 
            />
            <img src={enStockLogo} alt="Logo del sitio" className="ProductCard__logo" loading="lazy" />
          </div>
        </Link>
      </div>

      <div className="ProductCard__data">

          <div
            className={`ProductCard__stock${
              product.inventoryTotal <= 0 ? ' ProductCard__stock--empty' : ''
            }`}>
            {product.inventoryTotal > 0 ? (
              <>
                <span className="ProductCard__stock--label">En Stock:</span>
                <span className="ProductCard__stock--value">
                  {product.inventoryTotal.toLocaleString('es-CO')}
                </span>
              </>
            ) : (
              'En-stock: en actualización'
            )}
          </div>

          {nextArrival && (
            <div className="ProductCard__arrival">
              <span className="ProductCard__arrival--label">En Camino:</span>
              <span className="ProductCard__arrival--value">
                {formatUnits(nextArrival.cantidad)}
              </span>
              <span className="ProductCard__arrival--date">el {nextArrivalDate}</span>
            </div>
          )}

          <Link to={`/productos/${product.slug}`} onClick={handleScrollToTop}>
            <h3 className="ProductCard__title">{truncateString(product.title, 30)}...</h3>
          </Link>

          {/* {displayPublicPrice && (
            <div className="ProductCard__prices">
              <span className="ProductCard__price--public">Precio público: {displayPublicPrice}</span>
            </div>
          )} */}

          <div className="ProductCard__footer">
            <Link to={`/productos/${product.slug}`} onClick={handleScrollToTop} className="btn btn-primary">
              Cotizar
            </Link>
          </div>

      </div>

    </div>
  );
};

export default ProductCard;